module.exports = __webpack_public_path__ + "static/img/auth.ab09daeb.png";